import React, { useEffect, useRef, useState } from "react";
import Mesh from "../assets/images/BGmesh2.svg";
import Bulb from "../assets/images/Yellobulb.png";
import see from "../assets/images/show.png";
import hide from "../assets/images/hide.png";
import whiteYellowLogo from "../assets/images/blueYellowLogo.png";
import AuthenticationService from "../../Authentication/AuthenticationService";
import MasterService from "../../Masters/MasterService";
import Header from "./Header";

const Login = () => {
  const passwordRef = useRef(null);
  const [show, setShow] = useState(false);
  const [clientId,setClientId] = useState("")
  const [prefix,setPrefix] = useState("")
  const [error,setError] = useState(false)

  const handleProceed = () =>{
    setError(false)
    if(clientId && prefix && clientId !=="" && prefix !==""){
    MasterService.ExistsbyClientidandprefix(clientId,prefix).then((res)=>{
      if(res.data){
        const url = `http://${prefix}.${window.location.host}/login`
        window.location.href = url
      }else{
        setError(true)
      }
    })
  }
  }

  const handleClientIdChange = (e) =>{
    setClientId(e.target.value)
    setError(false)
  }
  
  const handlePrefixChange = (e) =>{
    setPrefix(e.target.value)
    setError(false)
   } 
  return (
    <section
    className="tw-min-h-[100vh]  tw-w-[100vw] tw-max-w-[100vw] tw-bg-[length:100vw] tw-bg-no-repeat tw-bg-[#f1f1fa]"
    style={{ backgroundImage: `url(${Mesh})` }}
    >
    <Header/>
    <div className="tw-h-full tw-pt-[10vh] lg:tw-pt-28 tw-pb-10 lg:tw-pb-20 lg:tw-px-16 xl:tw-pt-[20vh] xl:tw-px-[8vw] 2xl:tw-px-[12vw]">
      <div className="tw-h-full tw-flex tw-justify-between max-lg:tw-flex-col-reverse ProductSansRegular">
        <div className="tw-h-[100%] tw-flex tw-flex-col tw-justify-between max-lg:tw-w-fit max-lg:tw-mx-auto">
          <div className="tw-text-[#323436] max-lg:tw-hidden">
            <div className="tw-flex tw-gap-2">
              <img className="tw-w-8 xl:tw-w-10 2xl:tw-w-12" src={Bulb} alt="" />
              <h1 className="tw-text-xl xl:tw-text-2xl 2xl:tw-text-3xl tw-self-end">Tips !!</h1>
            </div>
            <ol className="tw-list-decimal tw-mt-10 tw-ml-14 tw-text-sm xl:tw-text-base 2xl:tw-text-lg tw-space-y-2 xl:tw-space-y-3 tw-tracking-tight">
              <li>Kindly log in with your respective credentials</li>
              <li>
                Avoid opening the Finanzz.in app in multiple browsers to prevent
                loss of unsaved data.
              </li>
              <li>Maintain password secrecy to protect your data.</li>
              <li>Refer to the knowledge base to understand Finanzz workflows.</li>
              <li>
                Configure your GST details in settings to use the e-invoice
                feature.
              </li>
              <li>
                Finanzz is VAT compatible. Please select your tax regime as per
                your country's standards.
              </li>
            </ol>
          </div>
          <div className="tw-flex tw-flex-col tw-w-fit tw-ms-2 lg:tw-ms-12 max-sm:tw-mt-auto">
            <div className="tw-flex tw-flex-wrap tw-gap-[5vw] lg:tw-gap-[12vw] tw-w-fit tw-text-[15px] xl:tw-text-lg">
              <div>
                <h3>Support :</h3>
                <p className="tw-text-[#2B27B9]">Email : Suppot@finanzz.in </p>
              </div>
              <div>
                <h3>Knowledgebase :</h3>
                <p className="tw-text-[#2B27B9]">https://finanzz.in/helpdocs</p>
              </div>
            </div>
            <nav className="tw-mt-10 tw-mx-auto">
              <ul className="tw-flex tw-flex-wrap tw-gap-5 tw-text-sm xl:tw-text-base tw-text-[#377586]">
                <li>- Home</li>
                <li>- Privacy Policy</li>
                <li>- Terms & Conditions</li>
                <li>- Pricing</li>
              </ul>
            </nav>
          </div>
        </div>
        <div className="ProductSansRegular tw-flex tw-flex-col max-lg:tw-w-full max-lg:tw-mx-auto">
          {/* <h2 className="2xl:tw-mt-5 tw-text-lg xl:tw-text-2xl tw-tracking-wider">Welcome back !</h2> */}
         {error && <h3 className="xl:tw-text-xl tw-w-fit tw-text-red-600">
            Invalid Credentials
          </h3>}
          <div className="tw-mt-2">
            <h3 className="ProductSansLight xl:tw-text-2xl">Account Login</h3>
            <div className="tw-mt-3 xl:tw-mt-5 tw-flex tw-flex-col tw-gap-3 2xl:tw-gap-5">
            <div className="tw-relative">
                <label
                  className="tw-text-[#949494] tw-bg-[#f1f1fa] tw-text-xs xl:tw-text-base tw-px-2 tw-absolute tw-left-[8%] tw-translate-y-[-50%] tw-tracking-wider"
                  htmlFor="username"
                >
                  Client Id
                </label>
                <input
                  className="tw-border tw-border-1 tw-border-[#004b6d] tw-rounded-[4px] tw-outline-none tw-bg-[#f1f1fa] tw-w-full tw-py-1 xl:tw-py-2 tw-px-2 tw-text-base xl:tw-text-base"
                  type="text"
                  name="clientid"
                  value={clientId}
                  onChange={handleClientIdChange}
                />
              </div>
              <div className="tw-relative">
                <label
                  className="tw-text-[#949494] tw-bg-[#f1f1fa] tw-text-xs xl:tw-text-base tw-px-2 tw-absolute tw-left-[8%] tw-translate-y-[-50%] tw-tracking-wider"
                  htmlFor="username"
                >
                  Prefix
                </label>
                <input
                  className="tw-border tw-border-1 tw-border-[#004b6d] tw-rounded-[4px] tw-outline-none tw-bg-[#f1f1fa] tw-w-full tw-py-1 xl:tw-py-2 tw-px-2 tw-text-base xl:tw-text-base"
                  type="text"
                  name="username"
                  onChange={handlePrefixChange}
                />
              </div>
              {/* <div className="tw-relative">
                <label
                  className="tw-text-[#949494] tw-bg-[#f1f1fa] tw-text-xs xl:tw-text-base tw-px-2 tw-absolute tw-left-[8%] tw-translate-y-[-50%] tw-tracking-wider"
                  htmlFor="password"
                >
                  Password
                </label>
                <input
                  className="tw-border tw-border-1 tw-border-[#004b6d] tw-rounded-[4px] tw-outline-none tw-bg-[#f1f1fa] tw-w-full tw-py-1 xl:tw-py-2 tw-px-2 tw-text-base xl:tw-text-base"
                  ref={passwordRef}
                  type={show ? "text" : "password"}
                  name="password"
                  onChange={(e) => saveFormdata(e)}
                />
                <div
                  className="tw-absolute tw-right-3 tw-top-[50%] -tw-translate-y-[50%] tw-text-sm tw-cursor-pointer"
                  onClick={() => setShow(!show)}
                >
                  <img className="tw-w-4 xl:tw-w-6" src={show ? hide : see} alt="" />
                </div>
              </div> */}
              <button className="tw-text-white xl:tw-text-[22px] ProductSansLight tw-bg-[#004b6d] tw-py-1 xl:tw-py-2 tw-rounded-[4px] tw-shadow-[4.7px_9.4px_9.4px_rgba(0,0,0,0.20)] hover:tw-scale-[1.05] tw-transition focus:tw-outline-none" onClick={handleProceed}>
                Proceed
              </button>
              {/* <button className="tw-text-white xl:tw-text-[22px] ProductSansLight tw-bg-[#65d2ef] tw-py-1 xl:tw-py-2 tw-rounded-[4px] tw-shadow-[4.7px_9.4px_9.4px_rgba(0,0,0,0.20)] hover:tw-scale-[1.05] tw-transition">
                Signup
              </button> */}
            </div>
            {/* <p className="tw-text-[#5c6c72] tw-text-sm xl:tw-text-lg ProductSansLight tw-mt-6">
              Forgot Password ?
            </p> */}
          </div>
          <img className="tw-w-60 xl:tw-w-72 tw-mt-10 lg:tw-mt-auto tw-mx-auto tw-mb-4" src={whiteYellowLogo} alt="" />
        </div>
      </div>
    </div>
  </section>
  
  );
};

export default Login;
